module.exports = __webpack_public_path__ + "img/like-active.b9920063.png";